export const black = '#222';
export const gray = '#f8f8f8';

/** Min-width breakpoints (styled-system convention for responsive props) */
export const breakpoints = ['640px', '768px', '1024px', '1280px'] as const;

/** Max-width breakpoints (former `theme.media.*` helpers) */
export const mediaMax = {
  sm: '640px',
  md: '768px',
  lg: '1024px',
  xl: '1280px',
} as const;

export const theme = {
  colors: {
    black,
    gray,
  },
  fill: {
    black,
  },
  borderColor: {
    black,
  },
  fontFamilies: {
    default: {
      fontFamily: "Lato,'Helvetica Neue',Arial,Helvetica,sans-serif",
      fontSize: '14px',
    },
    alt: {
      fontFamily: "'Montserrat', sans-serif",
      fontStyle: 'normal',
      fontWeight: 300,
      letterSpacing: '4px',
      fontSize: '12px',
    },
  },
  fontSizes: ['12px', '14px', '16px', '18px', '20px', '23px'],
  breakpoints: [...breakpoints],
};
